<template>
  <div>
    <div class="form-container ou-donation-form">
      <div class="holder jsu-forms">
        <PaymentForm class="form-horizontal">
          <h4 class="chooseamoun__title">Choose an amount</h4>
          <FormSection title="">
            <div class="fancy">
              <AmountSelectorList/>
              <ErrorLabel field="amount" />
            </div>
          </FormSection>
          <FormSection title="Make it monthly!">
            <div class="frequency">
              <PaymentOptions addMonthly monthlyText="Yes, Count me in!" oneTimeText="No, Donate once"/>
            </div>
          </FormSection>
          <FormSection title="Personal Information">
            <FormRow inline>
              <FormCol field="title" :flex="1" />
              <FormCol field="firstName" :flex="2" />
              <FormCol field="lastName" :flex="2" />
            </FormRow>
            <FormRow inline>
              <FormCol field="email" />
              <FormCol field="phone" />
            </FormRow>
            <FormRow inline>
              <Consent privacy="https://jsu.org/privacy-policy/"/>
            </FormRow>              
            <DonorAddress />
            <br />
            <FormRow>
              <NewsletterSubscribe
                text="Click here to stay updated on the JSU campaign"/>
            </FormRow>
            <div class="labelcomany">
              <FormRow>
                <input
                  type="checkbox"
                  id="contact"
                  name="contact"
                  @click="setValue('custom.contact', $event.target.checked)"
                />
                <FormLabel for="contact" class="company__match">
                  My company can match my donation, please reach out for next steps.</FormLabel
                >
              </FormRow>
            </div>
          </FormSection>
          <FormSection title="Payment Information" last>
            <FormRow inline>
              <PaymentType cc_text="Credit Card" check_text="Check" />
            </FormRow>
            <FormRow inline>
              <FormCol field="card" :showLabel="false"/>
            </FormRow>
            <div
              v-if="form.gateway === 'check'"
            >
              <div style="text-align: center; line-height: 1.6;">
                <h4>Mailing Check Info:</h4>
                <div>
                  Please mail your check to the following address:
                  <p>
                    <strong>
                      JSU Silcon Valley/West Coast<br />
                      9831 West Pico Blvd.<br />
                      Los Angeles, CA 90035
                    </strong>
                  </p>
                </div>
              </div>
            </div>
          </FormSection>
          <PaymentButton showAmount btnText="Donate"/>
          <div class="form__tax" style=" line-height: normal; text-align: center; font-style: italic; padding-top: 34px; ">All donations are tax deductible <br>Tax ID: 135623717</div>
        </PaymentForm>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, onMounted, ref, watch} from 'vue';
import { usePaymentForm } from "~/shared/use-payment-form";
import { queryParams } from "~/shared/query-params";

import AmountSelectorList from '~/components/amount-selector-list.vue';

export default defineComponent({
  props: {
    subCampaign: String,
  },  setup() {
    const feePercent = 2.5
    const { getValue, settings, setValue, form } = usePaymentForm();
    watch(
      () => form.value.applications[0].department,
      (val) => {
        if (val == "NCSY_Tristate" || !val) {
          setValue("applications.0.campaign", "JSU Emergency");
        } else {
          setValue("applications.0.campaign", "Emergency JSU");
        }
      }
    );

    const params = queryParams();

    if (params.designation) {
      //@ts-ignore
      switch (params.designation) {
        case "Atlanta+Region":
          setValue("applications.0.department", "NCSY_Atlanta");
          break;
        case "Atlantic+Seaboard":
          setValue("applications.0.department", "NCSY_AtlanticSeaboard");
          break;
        case "Canada":
          setValue("applications.0.department", "NCSY_Canada");
          break;
        case "Central+East":
          setValue("applications.0.department", "NCSY_CentralEast");
          break;
        case "Midwest+NCSY":
          setValue("applications.0.department", "NCSY_Midwest");
          break;
        case "NCSY":
          setValue("applications.0.department", "NCSY");
          break;
        case "NY+NJ":
          setValue("applications.0.department", "NCSY_Tristate");
          break;
        case "NCSY_Tristate":
          setValue("applications.0.department", "NCSY_Tristate");
          break;
        case "NCSY_NewYork":
          setValue("applications.0.department", "NCSY_Tristate");
          break;
        case "Northeast":
          setValue("applications.0.department", "NCSY_NewEngland");
          break;
        case "Oregon+NCSY":
          setValue("applications.0.department", "NCSY_Portland");
          break;
        case "Southern+NCSY":
          setValue("applications.0.department", "NCSY_Southern");
          break;
        case "Southwest":
          setValue("applications.0.department", "NCSY_Southwest");
          break;
        case "West+Coast+NCSY":
          setValue("applications.0.department", "NCSY_WestCoast");
          break;
      }
    }

    if (params.source == 'telemarketing') {
      setValue('applications.0.campaign', 'ADM Emergency JSU')
      setValue('applications.0.department', 'NCSY')
    }

    return {
      feePercent,
      form,
      getValue,
      settings,
      setValue,
    }
  },
})
</script>
<style scoped lang="scss">
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
h3.subtitle {
  text-align: center;
  color: #561045;
  font-size: 22px;
  margin-top: 0px;
  margin-bottom: 35px;
}
::v-deep h2 {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 600;
  font-size: 30px;
  line-height: 36px;
  margin-bottom: 20px;
  color: #005AE3;
}
::v-deep .styled-radio--ou-donation.styled-radio {
  .radio-part {
    min-width: 33%;
    flex: 1;
    padding-right: 10px;
    padding-left: 0;
    max-width:33%;
    margin-bottom: 16px;
    &:nth-child(6n) {
      padding-right: 10px;
    }
    &:nth-child(9) {
      min-width: 64%;
      max-width: 64%;
      @media (max-width: 500px) {
        min-width: 92%;
        max-width: 92%;
      }
    }
    label {
      background: #2773e7;
      border-radius: 8px;
      font-style: normal;
      border: 1px solid #5d6165;
      font-weight: 500;
      font-size: 18px;
      line-height: 26px;
      color: black;
    }
    &:nth-child(-n+3) {
      label {
        background: #DEEAFB;
      }
    }
    &:nth-child(n+5):nth-child(-n+8) {
      label {
        background:#7baaec;
      }
    }
    &:nth-child(9) {
      .money_format.label-amount {
        &:after {
          content: " - Sponsor a JSU for a day";
        }
      }
    }
  }
  .money_format.label-amount {
    width: 100%;
    position: relative;
  }
}
::v-deep .styled-radio--ou-donation.styled-radio input[type='radio']:checked + label {
  background: #005AE3 !important;
  color: white !important;
}
::v-deep .form-container.ou-donation-form {
  box-shadow: none;
  padding: 0px;
  margin: 0px 0px 40px;
  max-width: 100%;
}
::v-deep .styled-radio-container.styled-radio-container--ou-donation.row .radio-part {
  min-width: 45%;
  max-width: 45%;
}
::v-deep .styled-radio-container--ou-donation.styled-radio-container label {
  background: #FFFFFF;
  border: 1px solid #DCE7F8;
  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
  border-radius: 24px;
}

::v-deep .fancy .styled-radio-container--ou-donation.styled-radio-container label {
  background: #FFFFFF;
  border: 1px solid #DCE7F8;
  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
  border-radius: 24px;
      flex-flow: column;
    justify-content: center;
        padding: 0px;
    align-items: center;
    .money_format.label-amount {
    width: 100%;
    max-width: 100%;
    font-size: 18px;
    line-height: 26px;
    color: #000;
    padding: 8px;
}
span.label-description {
    flex-flow: column;
    justify-content: center;
    align-items: center;
    padding: 6px;
     span {
    color: #005ae3;
    font-size: 16px;
    padding-bottom: 4px;
}
i {
    font-size: 14px;
    color: #222;
    text-align: center;
}
}
}
::v-deep .fancy .styled-radio-container--ou-donation.styled-radio-container input[type=radio]:checked + label .label-amount{
  color: white;
  span.label-description span{
    color: #ffffff;
    i{
      color: #ffffff;
    }
  }
}
::v-deep .fancy .styled-radio-container--ou-donation.styled-radio-container input[type=radio]:checked + label{
  color: white;
  span.label-description span{
    color: #ffffff;
      }
    span.label-description{
    
    i{
      color: #ffffff;
    }
  }
}
::v-deep .styled-radio-container--ou-donation.styled-radio-container input[type="radio"]:checked + label,
::v-deep #donate-widget-form-submit {
  background: #005AE3;
  box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
  border-radius: 24px;
  font-weight: 600 !important;
  color: white;
}
::v-deep .styled-radio--ou-donation .amount_other__wrapper {
  margin-bottom: 10px;
  margin-right: 0;
  margin-bottom: 15px;
  overflow: hidden;
  border: 1px solid black;
  border-radius: 4px;
  padding-left: 5px;
  flex: 1;
  overflow: hidden;
  min-width: 34%;
  max-width: 34%;
  line-height: 1;
  @media (max-width: 500px) {
    min-width: 45%;
    max-width: 45%;
  }
  input#amount_other_field {
    height: 46px;
    color: black;
    font-weight: 500;
    font-size: 18px;
    line-height: 26px;
  }
}
.fee-info-container {
  background: #f2f5f8;
  padding: 15px;
  border-radius: 4px;
  margin-top: 15px;
  line-height: 1.4;
  font-size: 13px;
  input[type='checkbox'] {
    margin-right: 7px;
  }
  .amount {
    font-weight: bold;
    display: inline-block;
  }
  .inline-block {
    display: inline-block;
  }
  .edit {
    color: #0075ff;
    cursor: pointer;
    margin-left: auto;
    text-decoration: underline;
  }
  ::v-deep label {
    font-size: 13px;
  }
  .flex {
    display: flex;
    margin-top: 10px;
    input {
      margin-top: 4px;
    }
  }
}
h4.chooseamoun__title {
  color: var(--primary-dark-blue, #000453);
  font-family: 'Poppins';
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 30px; /* 150% */
  margin: 0px 0px 20px;
}
::v-deep .labelcomany label {
  padding-left: 4px;
  margin-bottom: 0px;
}
.company__match {
  font-weight: 500 !important;
  font-family: "Poppins" !important;
  @media (min-width: 500px) {
    font-size: 18px !important;
  }
}
.labelcomany {
  background: #ffff00;
  padding: 4px 0px 0px 8px;
}

::v-deep  button#donate-widget-form-submit{
  span.flex span{
    display: flex;
  }
}

::v-deep .fancy .styled-radio-container--ou-donation.styled-radio-container .amount_other__wrapper:before{
  height: auto !important;
}

::v-deep .fancy .styled-radio-container--ou-donation.styled-radio-container{
#amount_other {
    max-width: 100%;
    margin-left: 80px;
}
}
</style>

